export default "__VITE_ASSET__BF1xGOdg__"